import { TranscodingStatuses } from '../constants/transcoding-statuses';
import { eventsList } from '../events/list';
import { emit } from '../events/notifier';
var POLLING_TIMEOUT = 60 * 1000;
export function initPolling(settings, adapter, itemMapper, http, _temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      _ref$path = _ref.path,
      path = _ref$path === void 0 ? '/files' : _ref$path;

  return function (itemId) {
    function emitItemUpdateEvent(result) {
      var event = emit(adapter, eventsList.ITEM.UPDATE, {
        arguments: [result.data, result.data]
      });
      event.resolve(result);
    }

    return new Promise(function (resolve, reject) {
      function checkItemStatus() {
        setTimeout(function () {
          http.get("" + settings.apiUrl + path + "/" + itemId, null, {
            cache: false
          }).then(function (response) {
            var status = response.data.op_status;

            if (status === TranscodingStatuses.READY) {
              var responseItemId = response.data.file_name;
              adapter.item.get(responseItemId).then(emitItemUpdateEvent);
              resolve(responseItemId);
              return;
            }

            var result = itemMapper(response.data, settings, {}, true);
            emitItemUpdateEvent({
              data: result
            });

            if (status === TranscodingStatuses.FAILED) {
              reject('Item transcoding failed');
              return;
            }

            checkItemStatus();
          })["catch"](checkItemStatus);
        }, POLLING_TIMEOUT);
      }

      checkItemStatus();
    });
  };
}